import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import App from "./App";
import ProtectedRoute from "./routers/protectedRoute";
import { MsalProvider } from "@azure/msal-react";
import { getMsalInstance } from "@src/redux/services/config";
import LoginEmail from "./pages/login-email/login-email";

const AppRoutes = () => {
  const msalInstance = getMsalInstance();

  if (!msalInstance) {
    return (
      <Switch>
        <Route exact path="/login-email" component={LoginEmail} />
        <Redirect to="/login-email" />
      </Switch>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <Switch>
        <Route exact path="/login-email" component={LoginEmail} />
        <ProtectedRoute path="/" component={App} />
      </Switch>
    </MsalProvider>
  );
};

export default AppRoutes;
